import { Grid, Box, Typography } from "@mui/material"
import CHECK from './assets/CHECK.svg'
import {getInsurers} from "@modals/ModalAmpliaIntegral/utils";
import { useSelectedQuoteStore } from "@store/QuoteStore";


export const DataConfirm = () => {

    const { selectedQuote} = useSelectedQuoteStore();
    let insurer:string = selectedQuote.insurance.toLocaleUpperCase();
    const Data = getInsurers(insurer)

    return (
        <Grid
        container
        width={'90%'}
        direction="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
        margin={'auto'}
      >
        {Data.map((p: any, i: number) => (
         
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="flex-start"
              spacing={{ xs: 0, sm: 0 }}
            >
              <Grid item xs={1}>
                <Box
                component={'img'}
                src={CHECK}
                alt='Check'
                />                  
              </Grid>
              <Grid item xs={11}>
                <Typography
                  style={{
                    color: 'var(--Black, #212121)',
                    fontFamily: 'Montserrat',
                    fontSize: '12px',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    lineHeight: 'normal',
                  }}
                >
                  {' '}
                  {p.description}
                </Typography>
              </Grid>
            </Grid>
        
        ))}
      </Grid>
    )
}